import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, Divider, Tab, Tabs } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useTranslation } from 'react-i18next';
import { routePaths } from '../../../../routePaths';
import { ActionableBox, SecondaryToolbar, Typography } from '../../../../ui-kit';
import OrderDetail from './OrderDetail';

const OrderDetailsView = () => {
    const { params: { id } } = useRouteMatch();
    const [activeTab, setActiveTab] = useState<'details' | 'timeline'>('details');
    const history = useHistory();
    const { t } = useTranslation();

    const handleBack = () => history.push(routePaths.orders);

    const handleTabChange = (_event: React.ChangeEvent<unknown>, value: 'details' | 'timeline') => {
        setActiveTab(value);
    };

    return (
        <>
            <SecondaryToolbar>
                <Box display="flex" flexGrow={1}>
                    <ActionableBox
                        display='flex'
                        alignItems='center'
                        onClick={handleBack}
                        mr={3}
                    >
                        <Box component='span' mr={0.5}>
                            <ArrowBackIcon color='primary' />
                        </Box>
                        <Typography color='primary'>
                            {t('Back')}
                        </Typography>
                    </ActionableBox>
                    <Box py={1}>
                        <Divider orientation='vertical' />
                    </Box>
                    <Box flexGrow={1}>
                        <Tabs
                            onChange={handleTabChange}
                            value={activeTab}
                            centered
                            indicatorColor='primary'
                        >
                            <Tab value='details' label={t('Details')} />
                            <Tab value='timeline' label={t('Timeline')} />
                        </Tabs>
                    </Box>
                </Box>
            </SecondaryToolbar>
            <Box flex={1} display='flex'>
                <OrderDetail activeTab={activeTab} orderId={id} />
            </Box>
        </>
    );
};

export default OrderDetailsView;
